import axios from 'axios'
import fetch from '@/utils/fetch'
// const apiConfig = require('../../static/config.json')
const fileLoadPath =window.Glob.BASE_URL;
const apiUrl = window.Glob.BASE_URL;


//获取时间
export function getYearList() {
  return fetch({
    url: apiUrl + '/api/DateTimeHelper/GetYearList',
    method: 'post'
  })
}

export function getWeekListOfMonth(data) {
  return fetch({
    url: apiUrl + '/api/DateTimeHelper/GetWeekListOfMonth?year='+data.year+"&month="+data.month,
    method: 'post'
  })
}
export  function getDateTime() {
  return  fetch({
    url: apiUrl + '/api/DateTimeHelper/GetDateTime',
    method: 'post'
  })
}


// WEBPACK FOOTER //
// ./src/api/dateTimeHelperApi.js